import { useRef, useState, useEffect } from 'react'

import Styles from './DocCardSlider.module.scss'
import cx from 'classnames'
import { AlgoliaArticle } from 'types'
import ChevronRight24 from 'assets/img/chevron-right-24'
import MiniDocCard from 'components/MiniDocCard/MiniDocCard'

interface Props {
  articles: AlgoliaArticle[]
  variant?: string
  cardComponent?: (article: AlgoliaArticle, className: string) => JSX.Element
}

const DocCardSlider = ({ articles, variant, cardComponent }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(false)

  useEffect(() => {
    if (containerRef.current) {
      if (containerRef.current.scrollWidth > containerRef.current.clientWidth) {
        setCanScrollRight(true)
      }
    }
  }, [articles])

  return (
    <div className={cx(Styles.container, { [Styles[variant || '']]: true })}>
      <div
        className={Styles.scrollContainer}
        ref={containerRef}
        onScroll={() => {
          if (containerRef.current) {
            if (!canScrollLeft && containerRef.current.scrollLeft > 0) {
              setCanScrollLeft(true)
            }
            if (canScrollLeft && containerRef.current.scrollLeft === 0) {
              setCanScrollLeft(false)
            }
            const rightPos = containerRef.current.scrollLeft + containerRef.current.clientWidth
            if (!canScrollRight && rightPos < containerRef.current.scrollWidth) {
              setCanScrollRight(true)
            }
            if (canScrollRight && rightPos === containerRef.current.scrollWidth) {
              setCanScrollRight(false)
            }
          }
        }}
      >
        {articles.map((a) =>
          cardComponent ? (
            cardComponent(a, cx(Styles.docCard))
          ) : (
            <MiniDocCard article={a} className={Styles.docCard} key={a.objectID} />
          ),
        )}
      </div>
      {canScrollLeft && (
        <div
          className={Styles.leftButton}
          onClick={() => {
            if (containerRef.current) {
              containerRef.current.scrollTo({
                left: containerRef.current.scrollLeft - containerRef.current.clientWidth,
                behavior: 'smooth',
              })
            }
          }}
        >
          {ChevronRight24}
        </div>
      )}
      {canScrollRight && (
        <div
          className={Styles.rightButton}
          onClick={() => {
            if (containerRef.current) {
              containerRef.current.scrollTo({
                left: containerRef.current.scrollLeft + containerRef.current.clientWidth,
                behavior: 'smooth',
              })
            }
          }}
        >
          {ChevronRight24}
        </div>
      )}
    </div>
  )
}

export default DocCardSlider
